import isEmpty from './isEmpty'
//------------------
// get prop prefix
//------------------
export default function getPropPrefix(prop, digits = 3) {
  // console.log('-----------------------')
  // console.log('In getPropPrefix')
  //------------
  // get prefix
  //------------
  if (isEmpty(prop)) {
    return null
  }

  const pfx = prop.substring(0, digits)
  return pfx
}
